// extracted by mini-css-extract-plugin
module.exports = {"image":"manage-variant_image__22vAJ","optionName":"manage-variant_optionName__1k5ou","imageLogo":"manage-variant_imageLogo__3mgv7"};